export class TabSiFunc {
  cd: number;
  ds: string;

  constructor(d?) {
    if (d) {
      this.cd = d.cd ? d.cd : null;
      this.ds = d.ds ? d.ds : null;
    }
  }
}
